import React from 'react';
import styled from 'styled-components';
import { compose, space, variant } from 'styled-system';

import type {
  FontWeightProps,
  TextAlignProps,
  TextColorProps,
  TextDecorationProps,
  TextTransformProps,
  ThemeTextSizes,
} from '@rover/kibble/styles';
import {
  DSTokenMap,
  fontWeight,
  textAlign,
  textColor,
  textDecoration,
  textTransform,
} from '@rover/kibble/styles';

import Box from '../Box';
import type { SpacingSystemProps } from '../styledSystemPropTypes';

type TextNodes = 'span' | 'div' | 'label' | 'legend' | 'caption';

export type Props = SpacingSystemProps &
  TextAlignProps &
  TextColorProps &
  FontWeightProps &
  TextTransformProps &
  TextDecorationProps & {
    as?: TextNodes;
    size?: ThemeTextSizes;
    children: any;
  };

const StyledText = styled(Box)(
  // Resets values in case of global styles
  {
    padding: '0',
    margin: '0',
    border: '0 none',
  },
  variant({
    prop: 'size',
    variants: {
      // TODO: move these styles to Style Dictionary to format into theme.ts
      100: {
        fontSize: DSTokenMap.TEXT_100_FONT_SIZE,
        lineHeight: DSTokenMap.TEXT_100_LINE_HEIGHT,
      },
      200: {
        fontSize: DSTokenMap.TEXT_200_FONT_SIZE,
        lineHeight: DSTokenMap.TEXT_200_LINE_HEIGHT,
      },
      300: {
        fontSize: DSTokenMap.TEXT_300_FONT_SIZE,
        lineHeight: DSTokenMap.TEXT_300_LINE_HEIGHT,
      },
    },
  }),
  compose(textAlign, textColor, fontWeight, textDecoration, textTransform, space) // Apply last to avoid being overwritten by resets and variant styles
);

function Text(props: Props): any {
  return <StyledText {...props} />;
}

Text.defaultProps = {
  size: '200',
  as: 'span',
};

export default Text;



// WEBPACK FOOTER //
// ../kibble/components/Text/Text.tsx